import { UNIT_STATUS_ACTIVE, UNIT_STATUS_INACTIVE } from '@apps-common/config/unit-filter'
import { DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS } from '@apps-common/stores'
import { IPortalUnitFilterDefaults } from '@apps-common/types/portal/unit'

export const PORTAL_UNIT_FILER_DEFAULTS_INACTIVE: IPortalUnitFilterDefaults = {
  state: {
    ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
    status: UNIT_STATUS_INACTIVE.value as string
    // hasNoActivation: true,
    // isActivated: false
  },
  filter: {
    hideStatus: true,
    // hideSite: true,
    hideBureau: true,
    hideTech: true,
    hideNetworkType: true,
    hideIsActivated: true,
    // hideAccountNo: true,
    // hideMobileNo: true,
    hideSortBy: true,
    hideReset: true
  }
}

export const PORTAL_UNIT_FILER_DEFAULTS_ACTIVE: IPortalUnitFilterDefaults = {
  state: {
    ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
    status: UNIT_STATUS_ACTIVE.value as string
    // hasNoActivation: true,
    // isActivated: false
  },
  filter: {
    hideStatus: true,
    // hideSite: true,
    hideBureau: true,
    hideTech: true,
    hideNetworkType: true,
    hideIsActivated: true,
    // hideAccountNo: true,
    // hideMobileNo: true,
    hideSortBy: true,
    hideReset: true
  }
}

export const PORTAL_UNIT_FILER_DEFAULTS_MONITORING_CHANGES: IPortalUnitFilterDefaults = {
  state: {
    ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
    status: UNIT_STATUS_ACTIVE.value as string,
    // hasNoActivation: true,
    isActivated: true
  },
  filter: {
    hideStatus: true,
    // hideSite: true,
    // hideBureau: true,
    // hideTech: true,
    // hideNetworkType: true,
    hideIsActivated: true,
    // hideAccountNo: true,
    // hideMobileNo: true,
    // hideSortBy: true,
    hideReset: true
  }
}

// export const PORTAL_UNIT_FILER_DEFAULTS_ACTIVATIONS_EXITING_UNIT: IPortalUnitFilterDefaults = {
//   state: {
//     ...DEFAULT_PORTAL_UNITS_FILTER_STORE_PROPS,
//     status: UNIT_STATUS_ACTIVE.value as string
//   },
//   filter: {
//     hideStatus: true,
//     hideNetworkType: true,
//     hideSortBy: true,
//     hidePinnedUnits: true,
//     hideReset: true
//   }
// }
